import { render, staticRenderFns } from "./DialogChangePlate.vue?vue&type=template&id=9123687e&scoped=true"
import script from "./DialogChangePlate.vue?vue&type=script&lang=js"
export * from "./DialogChangePlate.vue?vue&type=script&lang=js"
import style0 from "./DialogChangePlate.vue?vue&type=style&index=0&id=9123687e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9123687e",
  null
  
)

export default component.exports